import { mapActions, mapState } from 'vuex'
import { numberWithCommas } from '@/utils/moneyFormat'
import Skeleton from '@/components/Skeleton/Skeleton.vue'
import { sendGaEvent } from '@/utils/analytics'

export default {
  name: 'Time',
  components: {
    Skeleton,
  },
  mounted () {
    this.loadRate()
  },
  computed: {
    ...mapState({
      cguPrice: state => state.cguPrice
    }),
    loading () {
      return this.cguPrice === null
    },
    price () {
      if (this.cguPrice === null) {
        return '00.00'
      }
      return numberWithCommas(parseFloat(this.cguPrice).toFixed(2))
    },
    marketCap () {
      if (this.cguPrice === null) {
        return '00,000,000'
      }
      return numberWithCommas(Math.round(this.cguPrice * 1000000000).toString())
    }
  },
  methods: {
    ...mapActions({
      loadRate: 'loadRate'
    }),
    fallbackCopyTextToClipboard (text) {
      const textArea = document.createElement('textarea')
      textArea.value = text

      textArea.style.top = '0'
      textArea.style.left = '0'
      textArea.style.position = 'fixed'

      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()

      try {
        const successful = document.execCommand('copy')
        const msg = successful ? 'successful' : 'unsuccessful'
        console.log('Fallback: Copying text command was ' + msg)
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err)
      }

      document.body.removeChild(textArea)
    },
    copyTextToClipboard (text) {
      if (!navigator.clipboard) {
        this.fallbackCopyTextToClipboard(text)
        return
      }
      navigator.clipboard.writeText(text).then(() => {
        console.log('Async: Copying to clipboard was successful!')
      }, (err) => {
        console.error('Async: Could not copy text: ', err)
      })
    },
    copyAddress () {
      this.copyTextToClipboard('0x747d74db20cc422f39ab54edb2a3ce21f3c98af1')
    },
    onExchangeClick () {
      sendGaEvent('exchange_open')
    },
  }
}
